import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../header/header'
import Footer from '../footer/footer'
// import CountdownTimer from '../countdown/countdown-timer'
import AnalyticsOverlay from '../dev-tools/analytics-overlay'

export default function Layout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
      {/* <CountdownTimer /> */}
      {import.meta.env.DEV ? <AnalyticsOverlay /> : null}
    </>
  )
}
